<div dir="{{txtDir}}">
<router-outlet dir="{{txtDir}}" ></router-outlet>
<ng-template #customLoadingTemplate>
              <div class="custom-class">
              </div>
          </ng-template>
<ngx-loading [show]="loading" [config]="{ primaryColour:'#fff' ,secondaryColour: '#fff',tertiaryColour:'#fff',backdropBackgroundColour:'rgba(168,91,21)', backdropBorderRadius: '3px' ,fullScreenBackdrop:true }" [template]="customLoadingTemplate"></ngx-loading>  
</div>
